// Mise en page des pages publiques : en-tête, page, pied de page.
// L'espace connecté (/dashboard, /coach, /admin) garde sa propre mise en page.
import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "./site.css";
import "./apercus/apercus.css";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";

export default function SiteLayout() {
	const { pathname, hash } = useLocation();

	// Changement de page : on repart du haut (le défilement vit dans <body>).
	useEffect(() => {
		if (hash) return;
		document.body.scrollTo?.(0, 0);
		window.scrollTo(0, 0);
	}, [pathname, hash]);

	return (
		<div className="gs-site">
			<SiteHeader />
			<main className="gs-main">
				<Outlet />
			</main>
			<SiteFooter />
		</div>
	);
}
